export default {
    'diagram3b2-4': {
        'diagram-task': 'Q: How look?',
        'diagram-hint': 'Steps',
        'fixed-answer': 'We can make educated guesses about how to look for life on Mars',
        'element_4_1': 'Look for proteins essential for survival on Mars',
        'element_4_2': 'Target ubiquitous molecules',
        'element_4_3': 'Search for patterns in the debris',
        'diagram-description-1': 'Search for proteins essential for survival on Mars',
        'diagram-description-2': 'Search for enzymes that would survive Mars’s frigid temperatures',
        'diagram-description-3': 'Look for enzymes that would survive Mars’s ionizing radiation',
        'diagram-description-4': 'Target molecules ubiquitous throughout the microbial world',
        'diagram-description-5': 'Look for a universal component of all bacterial cell walls',
        'diagram-description-6': 'Look for evidence of life in the debris of large molecules',
        'diagram-description-7': 'Look for patterns in the debris',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b2/diagram4/i18n/en.js